import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import {
  FetchPaymentActivityResult,
  PaymentActivity,
  PaymentActivityState,
} from "./paymentActivity-state";
import { defaultGenericMeta, FilterProps } from "store/common";
import { fetchPayments } from "./paymentActivity-action";
import { RootState } from "store";

const paymentActivityEntityAdapter = createEntityAdapter<PaymentActivity>({});

export const paymentActivitySlice = createSlice({
  name: "paymentActivity",
  initialState:
    paymentActivityEntityAdapter.getInitialState<PaymentActivityState>({
      meta: { ...defaultGenericMeta },
    }),
  reducers: {
    setFilters(state, action: PayloadAction<FilterProps>) {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    clearFilter(state) {
      state.filters = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchPayments.fulfilled,
      (state, action: PayloadAction<FetchPaymentActivityResult>) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.status = "idle";
        const { results, ...serviceMeta } = action.payload;

        /*
          The following drops the Z from the date string. This essentially makes the 
          payment date the local user's time. Since we're only showing a date with 
          this property it should be OK to not care about when it was made.
         */
        results.forEach((pa) => {
          const paymentDate = pa.paymentDate as unknown as string;
          const index = paymentDate.indexOf("Z");
          if (index >= 0) {
            pa.paymentDate = paymentDate.substring(0, index) as unknown as Date;
          }
        });

        paymentActivityEntityAdapter.setAll(state, results);
        state.serviceMeta = serviceMeta;
      }
    );
    builder.addCase(fetchPayments.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(fetchPayments.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
  },
});

export const { selectAll: selectAllPaymentActivity } =
  paymentActivityEntityAdapter.getSelectors(
    (state: RootState) => state.paymentActility
  );

export const { setFilters, clearFilter } = paymentActivitySlice.actions;
export default paymentActivitySlice.reducer;
